import React from 'react'
import { connect } from 'react-redux';
import PlusIcon from './images/plus.png'
import SearchIcon from './images/search.png'
import './ChatSider.css'
import Axios from 'axios'
import { message } from 'antd'

class ChatSider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tabValue: "1",
            activeMessageId: -1,
            contactType: "",
            plusState: false,
            selectedTab: 1,
            isShowAddGroupModal: false,
            isShowAddFriendModal: false,
            responseFriendData: [],
            applyUserId: "", // 发起增加好友的id
            applyUserIds: [], // 发起新建群聊的好友id
            clusterName: "", // 标记"我的好友"列表
            showCheckFriendInfo: false,  // 切换申请好友界面只验证界面
            checkedFriendInfo: {}, // 选择的想要申请某一个好友信息
            checkTextArea: ""
        }
        this.searchRef = React.createRef()
    }

    // 切换tab
    handleTab = (e) => {
        this.setState({
            tabValue: e.target.value
        })
    }

    // 点击"+"中的新建群聊
    createGroup = () => {
        this.setState({
            plusState: false,
            isShowAddFriendModal: false,
            isShowAddGroupModal: true,
            applyUserIds: []
        })
        // 取消icon的焦点
        document.getElementById("create-modal").blur()
    }



    // 处理消息或者好友列表点击事件
    handleInfoItemClick = (id, contactType, ...args) => {
        const { tabValue } = this.state
        const { messageData } = this.props
        if (tabValue === "2") {

            this.setState({
                activeMessageId: id,
                contactType: contactType,
                tabValue: "1"
            }, () => {
                new Promise((resolve, reject) => {

                    messageData.some(item => {
                        // 判断会话列表中有没有该用户, 没有的话需要保存会话
                        if (item.contactType === "private" && item.receiverId === this.state.activeMessageId) {
                            resolve()
                        }
                    })
                    reject()
                }).then(() => {
                    console.log("无需保存会话")
                }).catch(() => {
                    console.log("保存会话")
                    const apiRoot = global.url.im
                    let data = {
                        "contactType": "private",
                        "senderId": this.props.onlineUserId,
                        "receiverId": this.state.activeMessageId,
                        "contactName": args[0],
                        "contactAvatar": args[1]
                    }
                    // 发起保存会话请求
                    Axios.post(`${apiRoot}/contact/save`, data).then(res => {
                        this.setState({})
                        return true
                    })
                })
            })

            this.setState({
                activeMessageId: id,
                contactType: contactType,
                tabValue: "1"
            }, () => {
                this.props.parent.getSiderMsg(this, this.state.activeMessageId, this.state.contactType)
            })
        } else {
            this.setState({
                activeMessageId: id,
                contactType: contactType
            }, () => {
                this.props.parent.getSiderMsg(this, this.state.activeMessageId, this.state.contactType)
            })
        }

    }


    // 查找好友
    handleSearchPerson = (event) => {
        const { user } = this.props;
        if (event.keyCode === 13) {
            // Axios.get(`${global.url.sys}/sys/user/search`, {
            Axios.get(`${global.url.sys}/api/instant-messaging/friend/myfriendofall?userId=${user.userId}`)
                .then(res => {
                    this.setState({
                        responseFriendData: res.data.payload.records
                    })
                })
        }

    }


    // 查找消息
    handleSearchMessage = (event) => {
        if (event.keyCode === 13) {
            setTimeout(() => {
                console.log(event.target.value)
            }, 2000)
        }
    }

    // 点击"+"中的添加好友
    createFriend = () => {
        this.setState({
            applyUserId: "",
            plusState: false,
            isShowAddGroupModal: false,
            isShowAddFriendModal: true,
            responseFriendData: []
        })
        // 取消icon的焦点
        document.getElementById("create-modal").blur()
    }

    // 切换至好友验证
    switchToCheckInfo = () => {

        const { responseFriendData, applyUserId } = this.state // 上一个状态
        if (!applyUserId) {
            message.info("请选择一位用户申请添加！")
            return
        }

        this.setState({
            showCheckFriendInfo: true
        })

        responseFriendData && responseFriendData.some((item) => {
            if (item.userId === applyUserId) {
                this.setState({
                    checkedFriendInfo: item // 新的状态
                }, () => {
                    return true
                })
            }
        })


    }


    // 发起好友请求
    hadleAddFriend = () => {

        let data = {
            "applyType": "private",
            "userId": this.props.onlineUserId,
            "applyFor": this.state.applyUserId,
            "source": "search",
            "content": this.state.checkTextArea
        }

        Axios.post(`${global.url.im}/apply/save`, data)
            .then(res => {
                message.info(res.data.message)
                this.setState({
                    isShowAddFriendModal: false,
                    showCheckFriendInfo: false
                })
            })
    }


    // 新建群聊
    handleAddGroup = () => {

        let memberArr = this.state.applyUserIds.map((item) => {
            return {
                "userId": item
            }

        })

        let data = {
            "groupName": "五湖四海皆",
            "groupOwnerId": this.props.onlineUserId,
            "groupAvatar": "http://p2.itc.cn/images01/20201224/390139c86f514db886b6ab8d4879e3d0.jpeg",
            "groupOwnerName": this.props.onlineUserId,
            "members": memberArr
        }


        Axios.post(`${global.url.im}/group/create`, data)
            .then(res => {
                message.info(res.data.message)
                this.setState({
                    isShowAddFriendModal: false,
                    showCheckFriendInfo: false
                })
            })
    }



    // 格式化时间
    formatTime = (time) => {
        let formatTime = new Date(Date.parse(time))

        return `${formatTime.getHours()}:${formatTime.getMinutes()}`

    }


    render() {
        const { tabValue, activeMessageId, activeFriendId, contactType, plusState, isShowAddGroupModal, isShowAddFriendModal, responseFriendData, showCheckFriendInfo, checkedFriendInfo, checkTextArea } = this.state;
        const { messageData, friendData } = this.props;
        return (
            <>
                <div style={{ display: "flex", flexDirection: "column", background: "#fff" }}>
                    <div style={{ width: "350px", height: "65px", padding: "0 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ width: "270px", height: "32px", border: "1px solid #00000026", display: "flex", alignItems: "center" }}>
                            <div style={{ background: `url(${SearchIcon})`, width: "20px", height: "20px", margin: "0 10px" }}></div>
                            <div>
                                <input
                                    ref={this.searchRef}
                                    placeholder="查找消息"
                                    className="chatsearch-message"
                                    onKeyDown={this.handleSearchMessage}
                                />
                            </div>
                        </div>
                        <div>
                            <div
                                id="create-modal"
                                style={{ background: `url(${PlusIcon})`, width: "32px", height: "32px", cursor: "pointer", position: "relative" }}
                                tabIndex="-1"
                                onFocus={() => {
                                    this.setState({ plusState: true })
                                }}
                                onBlur={() => {
                                    this.setState({ plusState: false })
                                }}
                            >
                                {
                                    plusState && <div style={{ zIndex: "2", position: "absolute", top: "32px", width: "170px", height: "90px", background: "#fff", boxShadow: "0 3px 6px 0 #00000029", display: "flex", flexDirection: "column" }}>
                                        <div style={{ width: "170px", height: "45px", padding: "0 16px" }}>
                                            <div
                                                style={{ width: "138px", height: "45px", lineHeight: "45px", textAlign: "center", borderBottom: "1px solid #d5d5d5", fontSize: "14px", color: "#000000a5", cursor: "pointer" }}
                                                onClick={this.createGroup}
                                            >
                                                新建群组
                                            </div>
                                        </div>
                                        <div style={{ width: "170px", height: "45px", padding: "0 16px" }}>
                                            <div
                                                style={{ width: "138px", height: "45px", lineHeight: "45px", textAlign: "center", fontSize: "14px", color: "#000000a5", }}
                                                onClick={this.createFriend}
                                            >
                                                添加好友
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{ height: "823px", display: "flex" }}>
                        <ul className="mytabs-ul">
                            <li>
                                <input id="tab1" type="radio" value="1" checked={tabValue === "1"} onChange={this.handleTab} />
                                <label htmlFor="tab1">消息</label>
                                <div className="content" style={{ display: "flex", flexDirection: "column" }}>
                                    {
                                        messageData.map((item, index) => {
                                            const chatmessageItemClass = (activeMessageId === item.receiverId && contactType === item.contactType)
                                                ? "chatmessage-item chatmessage-item-active" : "chatmessage-item"

                                            return (
                                                <div
                                                    onClick={() => { this.handleInfoItemClick(item.receiverId, item.contactType) }}
                                                    className={chatmessageItemClass}
                                                    key={`${index}-chatuser`}
                                                >
                                                    <div style={{ width: "36px", height: "36px", background: `url(${item.contactAvatar})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}></div>
                                                    <div style={{ width: "258px", height: "42px", marginLeft: "12px", marginLeft: "5px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                                        <div style={{ color: "#0072e5", fontSize: "16px", fontWeight: "bold", height: "21px", lineHeight: "21px" }}>
                                                            {item.contactName}
                                                        </div>
                                                        <div style={{ color: "#969696", fontSize: "16px", width: "240px", height: "21px", textAlign: "left", lineHeight: "21px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                            {item.lastMessageType === 'text' && item.lastMessage}
                                                            {item.lastMessageType === 'img' && '[图片]'}
                                                            {item.lastMessageType === 'file' && '[文件]'}
                                                        </div>
                                                    </div>
                                                    <div style={{ width: "31px", fontSize: "12px", color: "#00000072" }}>
                                                        {this.formatTime(item.updateTime)}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </li>
                            <li>
                                <input id="tab2" type="radio" value="2" checked={tabValue === "2"} onChange={this.handleTab} />
                                <label htmlFor="tab2">好友</label>
                                <div className="content" style={{ display: "flex", flexDirection: "column" }}>
                                    {
                                        friendData.map((item, index) => {
                                            const chatfriendItemClass = (activeFriendId === item.toUserId && item.contactType === "private")
                                                ? "friend-item friend-item-active" : "friend-item"

                                            return (
                                                <div
                                                    onClick={() => { this.handleInfoItemClick(item.toUserId, item.contactType, item.friendInfo.userName, item.friendInfo.avatar) }}
                                                    className={chatfriendItemClass}
                                                    key={`${index}-friend`}
                                                >
                                                    <div style={{ background: `url(${item.friendInfo.avatar})`, width: "36px", height: "36px", backgroundRepeat: "no-repeat", backgroundSize: "cover", margin: "0 20px" }}>
                                                    </div>
                                                    <div style={{ fontSize: "16px", color: "#8c8c8c" }}>
                                                        {item.friendInfo.userName}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                {
                    isShowAddGroupModal && <div style={{ zIndex: 9, position: "absolute", top: "50%", left: "50%", margin: "-217px 0 0 -223px", width: "435px", height: "446px", boxShadow: "0 4px 12px 0 #00000029", background: "#fff" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ padding: "16px 36px", width: "435px", height: "64px" }}>
                                <div style={{ width: "363px", height: "32px", background: "#f5f7fa", border: "1px solid #d3d3d3", outline: "none", display: "flex", alignItems: "center" }}>
                                    <div style={{ background: `url(${SearchIcon})`, width: "20px", height: "20px", margin: "0 10px" }}>
                                    </div>
                                    <div>
                                        <input
                                            style={{ width: "300px", height: "20px", outline: "none", border: "none", background: "#f5f7fa", }}
                                            placeholder="查找人员"
                                            onKeyDown={this.handleSearchPerson}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: "4px 16px", width: "435px", height: "70px", overflow: "hidden", display: "flex" }}>
                                {
                                    friendData.map((item, index) => {

                                        if (this.state.applyUserIds.includes(parseInt(item.friendInfo.userId))) {

                                            return (
                                                <div style={{ width: "46px", height: "54px", marginRight: "26px", }} key={`add-newgroupuser-${index}`}>
                                                    <div style={{ width: "46px", height: "36px", background: `url(${item.friendInfo.avatar})`, backgroundSize: "cover" }}>

                                                    </div>
                                                    <div style={{ width: "46px", height: "16px", lineHeight: "16px", marginTop: "3px", color: "#969696", fontSize: "12px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                        {item.friendInfo.friendName}
                                                    </div>
                                                </div>
                                            )
                                        } else {

                                            return <div key={`add-newgroupuser-${index}`}></div>
                                        }

                                    })
                                }
                            </div>
                            <div className="friendgroup-scrollbar" style={{ margin: "0 14px", width: "403px", height: "261px", overflow: "auto", }}>
                                {
                                    friendData.map((item, index) => {
                                        return (
                                            <div style={{ width: "403px", height: "49px", display: "flex" }} key={`add-friend-${index}`}>
                                                <div style={{ width: "50px", height: "49px", lineHeight: "49px", textAlign: "center" }}>
                                                    <input
                                                        type="checkbox"
                                                        name="newGroup"
                                                        // value={parseInt(item.userId)}
                                                        onChange={() => {
                                                            if (this.state.applyUserIds.includes(parseInt(item.friendInfo.userId))) {
                                                                this.state.applyUserIds.splice(this.state.applyUserIds.indexOf(parseInt(item.friendInfo.userId)), 1);
                                                                this.setState({
                                                                    applyUserIds: this.state.applyUserIds
                                                                })
                                                                return
                                                            }
                                                            this.setState({
                                                                applyUserIds: [parseInt(item.friendInfo.userId), ...this.state.applyUserIds]
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ width: "350px", height: "49px", display: "flex", alignItems: "center" }}>
                                                    <div style={{ background: `url(${item.friendInfo.avatar})`, height: "36px", width: "36px", backgroundSize: "cover", marginLeft: "8px" }}>

                                                    </div>
                                                    <div style={{ width: "300px", height: "49px", lineHeight: "49px", fontSize: "16px", color: "#595959", marginLeft: "8px" }}>
                                                        {item.friendInfo.userName}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ width: "435px", height: "51px", display: "flex", justifyContent: "space-between", background: "#fff" }}>
                                <div
                                    style={{ width: "217px", height: "51px", textAlign: "center", lineHeight: "51px", color: "#d3d3d3", cursor: "pointer" }}
                                    onClick={() => { this.setState({ isShowAddGroupModal: false }) }}
                                >
                                    取消
                                </div>
                                <div style={{ width: "217px", height: "51px", textAlign: "center", lineHeight: "51px", color: "#0072e5", cursor: "pointer" }}
                                    onClick={this.handleAddGroup}
                                >
                                    新建群聊
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    isShowAddFriendModal && !showCheckFriendInfo && <div style={{ position: "absolute", display: "flex", flexDirection: "column", top: "50%", left: "50%", margin: "-217px 0 0 -188px", width: "435px", height: "375px", boxShadow: "0 4px 12px 0 #00000029", background: "#fff" }}>
                        <div style={{ width: "435px", height: "65px", padding: "16.5px 36px" }}>
                            <div style={{ width: "363px", height: "32px", background: "#f5f7fa", border: "1px solid #d3d3d3", borderRadius: "4px", display: "flex", alignItems: "center" }}>
                                <div style={{ background: `url(${SearchIcon})`, width: "20px", height: "20px", margin: "0 10px" }}>
                                </div>
                                <div style={{ width: "300px", height: "20px" }}>
                                    <input
                                        style={{ width: "300px", background: "#f5f7fa", border: "none", outline: "none" }}
                                        placeholder="查找人员"
                                        onKeyDown={this.handleSearchPerson}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="friendgroup-scrollbar" style={{ width: "403px", height: "261px", margin: "0 16px", background: "#f5f7fa", overflow: "auto" }} >
                            {
                                responseFriendData.map((item, index) => {
                                    return (
                                        <div style={{ width: "403px", height: "49px", display: "flex" }} key={`add-friend-${index}`}>
                                            <div style={{ width: "50px", height: "49px", lineHeight: "49px", textAlign: "center" }}>
                                                <input
                                                    defaultChecked={false}
                                                    type="radio"
                                                    name="newfriend"
                                                    value={item.userId}
                                                    onChange={() => {
                                                        this.setState({
                                                            applyUserId: item.userId
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: "350px", height: "49px", display: "flex", alignItems: "center" }}>
                                                <div style={{ background: `url(${item.avatar})`, height: "36px", width: "36px", backgroundSize: "cover", marginLeft: "8px" }}>

                                                </div>
                                                <div style={{ width: "300px", height: "49px", lineHeight: "49px", fontSize: "16px", color: "#595959", marginLeft: "8px" }}>
                                                    {item.userName}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{ width: "435px", height: "48px", display: "flex", justifyContent: "space-between", background: "#fff" }}>
                            <div
                                style={{ width: "217px", height: "48px", textAlign: "center", lineHeight: "48px", color: "#d3d3d3", cursor: "pointer" }}
                                onClick={() => { this.setState({ isShowAddFriendModal: false }) }}
                            >
                                取消
                            </div>
                            <div style={{ width: "217px", height: "48px", textAlign: "center", lineHeight: "48px", color: "#0072e5", cursor: "pointer" }}
                                onClick={this.switchToCheckInfo}
                            >
                                添加好友
                            </div>
                        </div>
                    </div>
                }
                {
                    isShowAddFriendModal && showCheckFriendInfo && <div style={{ position: "absolute", display: "flex", flexDirection: "column", top: "50%", left: "50%", margin: "-217px 0 0 -188px", width: "435px", height: "375px", boxShadow: "0 4px 12px 0 #00000029", background: "#fff" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ width: "435px", height: "327px", borderBottom: "1px solid #e4e9f1", display: "flex" }}>
                                <div style={{ width: "155px", height: "327px", padding: "32px 26px", borderRight: "1px solid #e4e9f1", display: "flex", flexDirection: "column" }}>
                                    <div style={{ width: "102px", height: "102px", background: `url(${checkedFriendInfo.avatar})`, backgroundSize: "cover" }}>

                                    </div>
                                    <div style={{ marginTop: "16px" }}>
                                        {checkedFriendInfo.userName}
                                    </div>
                                </div>
                                <div style={{ width: "280px", height: "327px" }}>
                                    <div style={{ padding: "32px 0 22px 20px", color: "#595959", fontSize: "16px" }}>
                                        请输入验证信息：
                                    </div>
                                    <div style={{ margin: "0 20px", width: "240px", height: "220px", background: "#f5f7fa", border: "1px solid #e4e9f1" }}>
                                        <textarea value={checkTextArea} onChange={(e) => { this.setState({ checkTextArea: e.target.value }) }} style={{ width: "240px", height: "220px", resize: "none", outline: "none" }}>

                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "435px", height: "51px", display: "flex", justifyContent: "space-between", background: "#fff" }}>
                                <div
                                    style={{ width: "217px", height: "51px", textAlign: "center", lineHeight: "51px", color: "#d3d3d3", cursor: "pointer" }}
                                    onClick={() => { this.setState({ showCheckFriendInfo: false }) }}
                                >
                                    取消
                                </div>
                                <div style={{ width: "217px", height: "51px", textAlign: "center", lineHeight: "51px", color: "#0072e5", cursor: "pointer" }}
                                    onClick={this.hadleAddFriend}
                                >
                                    发送
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

const mapState = (state) => ({ //返回值  对应的是  组件的props  
    user: state.userReducer.get('user').toJS(),
    zd_user: state.userReducer.get('zd_user').toJS(),
})
const mapDispatch = (dispatch, ownProps) => ({
})

export default connect(mapState, mapDispatch)(ChatSider);